import { render, staticRenderFns } from "./save-dialog.vue?vue&type=template&id=ee0cba86&"
import script from "./save-dialog.vue?vue&type=script&lang=js&"
export * from "./save-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports